export interface Address {
  company: string;
  department: string;
  contact: string;
  street: string;
  postbox: string;
  postalCode: string;
  city: string;
  country: string;
  comment: string;
}

export function newAddress(): Address {
  return {
    company: "",
    department: "",
    contact: "",
    street: "",
    postbox: "",
    postalCode: "",
    city: "",
    country: "",
    comment: "",
  };
}

export function oneLine(address: Address): string {
  const street = address.street.trim();
  const postalCity = [address.postalCode, address.city]
    .map((value) => value.trim())
    .filter((value) => value !== "")
    .join(" ");

  return [street, postalCity].filter((value) => value !== "").join(", ");
}

export function addressListLabel(address: Address): string {
  return [
    address.company.trim(),
    address.street.trim(),
    [address.postalCode, address.city]
      .map((value) => value.trim())
      .filter((value) => value !== "")
      .join(" "),
    address.department.trim(),
    address.contact.trim(),
  ]
    .filter((value) => value !== "")
    .join(", ");
}

export function isEmptyAddress(address: Address): boolean {
  return Object.values(address).every((value) => value === "");
}

export function sameAddress(left: Address, right: Address): boolean {
  return (
    left.company === right.company &&
    left.department === right.department &&
    left.contact === right.contact &&
    left.street === right.street &&
    left.postbox === right.postbox &&
    left.postalCode === right.postalCode &&
    left.city === right.city &&
    left.country === right.country &&
    left.comment === right.comment
  );
}
